import { render, staticRenderFns } from "./RespostaCadastroProdutos.vue?vue&type=template&id=13ccfa2b"
import script from "./RespostaCadastroProdutos.vue?vue&type=script&lang=js"
export * from "./RespostaCadastroProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports